import { useTranslate } from '../../../../hooks/useTranslate';
import { GroupedOptions } from '../../DestinationSearch.types';
import { Amelia } from '../Amelia/Amelia';
import { EmptyState } from './Suggestions.styles';
import { SuggestionsList } from './SuggestionsList';

type Props = {
  query: string;
  groupedItems: GroupedOptions[];
  lastOptions: GroupedOptions[];
  isLoading: boolean;
  forceNoResults: boolean;
  hideAmeliaChat?: boolean;
  onRemoveItem: (label: string) => void;
};

export const Suggestions = ({
  query,
  groupedItems,
  lastOptions,
  isLoading,
  forceNoResults,
  hideAmeliaChat,
  onRemoveItem,
}: Props) => {
  const { t } = useTranslate();

  const totalItems = groupedItems.reduce(
    (acc, { items }) => acc + items.length,
    0
  );

  if (!forceNoResults && query.length < 2) {
    return null;
  }

  if (isLoading) {
    return <EmptyState>{t('explore.destinationSearch.loading')}</EmptyState>;
  }

  if (!totalItems && !lastOptions.length) {
    return (
      <>
        <EmptyState>{t('explore.amelia.info.noResult')}</EmptyState>

        {!hideAmeliaChat && <Amelia query={query} />}
      </>
    );
  }

  if ((!totalItems || !query) && lastOptions.length) {
    return (
      <>
        {lastOptions.map((group) => (
          <SuggestionsList
            key={group.label}
            groupedItems={group}
            onRemoveItem={onRemoveItem}
          />
        ))}

        {!hideAmeliaChat && <Amelia query={query} />}
      </>
    );
  }

  return (
    <>
      {groupedItems.map((group) => (
        <SuggestionsList key={group.label} groupedItems={group} />
      ))}
      {!hideAmeliaChat && <Amelia query={query} />}
    </>
  );
};
